import React, { useEffect, useState } from "react";
import { timeSince } from "../../utils/dashboard";
import moment from "moment";

function TimeAgo({ userCode, orgDashboardStore }) {
  const [counter, setCounter] = useState(0);
  const [timeAgo, setTimeAgo] = useState("");

  const updateCounter = () => {
    setCounter(Math.random());
    setTimeout(updateCounter, 1000);
  };

  useEffect(() => {
    if (!orgDashboardStore.heartRate) {
      return;
    }
    const timeSinceString = timeSince(
      moment(orgDashboardStore.heartRate.timestamp).toDate()
    );
    setTimeAgo(timeSinceString);
  }, [userCode, orgDashboardStore.heartRate, counter]);

  useEffect(() => {
    setTimeout(updateCounter, 1000);
  }, []);

  return <div> {timeAgo && timeAgo.length > 0 ? timeAgo + " ago" : ""}</div>;
}

export default TimeAgo;
